import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaChevronDown } from "react-icons/fa";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Type from "./Type";
import About from "../About/About";
import HomeHighlights from "./HomeHighlights";
import { PERSONAL_INFO } from "../../config/constants";

function Home() {
  const scrollToAbout = () => {
    const aboutSection = document.getElementById("about");
    if (!aboutSection) return;

    const navbarOffset = 80;
    const top =
      aboutSection.getBoundingClientRect().top +
      window.scrollY -
      navbarOffset;

    window.scrollTo({ top, behavior: "smooth" });
  };

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="align-items-center home-hero-row">
            <Col lg={7} className="home-header">

              <h1 className="home-title">
                <span className="main-name">{PERSONAL_INFO.name}</span>
              </h1>

              <div className="home-typewriter">
                <Type />
              </div>

              <HomeHighlights />

            </Col>

            <Col lg={5} className="home-image-col">
              <img
                src={homeLogo}
                alt="Software engineering illustration"
                className="img-fluid home-hero-image"
              />
            </Col>
          </Row>

          <div className="home-scroll-down-wrap">
            <button
              type="button"
              onClick={scrollToAbout}
              className="home-scroll-down"
              aria-label="Scroll to About Me"
            >
              <span>About Me</span>
              <FaChevronDown className="home-scroll-down-icon" />
            </button>
          </div>
        </Container>
      </Container>
      <About />
    </section>
  );
}

export default Home;
